
/* import EDButton from '../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../BaseComponents/Icon/EDIcon'; */
import EDTypography from '../../../../../BaseComponents/Typography/EDTypography';
import { ObjektVyKort } from '../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import { Theme, useTheme } from '@mui/material/styles';
import { TEDGAGravUPL_STATUSEnum } from '../../../../../globalQueryTypes';
import { GravplatsQuery_node_TEDGAGrav as IGravplatsNode } from './Queries/_QueryTypes/GravplatsQuery';

const getGraveStatusBorderColor = (
  nodeData: IGravplatsNode | null | undefined,
  theme: Theme
): string => {
  const colors = {
    red: theme?.customProperties?.Legend?.red.faded,
    orange: theme?.customProperties?.Legend?.orange.faded,
    lightGreen: theme?.customProperties?.Legend?.lightGreen.faded,
    gray: theme?.customProperties?.Legend?.gray.faded,
  };

  if (!nodeData) return colors.gray;

  const status = nodeData.UPL_STATUS;
  const gravratt = nodeData.Gravratt;
  const hasFutureDate = gravratt && new Date(gravratt) > new Date();

  //  Finns ej mer eller Kan ej upplåtas
  if (
    status === TEDGAGravUPL_STATUSEnum.FINNS_EJ_MER ||
    status === TEDGAGravUPL_STATUSEnum.KAN_EJ_UPPLATAS
  ) {
    return colors.red;
  }

  // Ej upplåten med framtida gravrätt
  if (status === TEDGAGravUPL_STATUSEnum.EJ_UPPLATEN && hasFutureDate) {
    return colors.orange;
  }

  //  Ej upplåten utan framtida gravrätt
  if (status === TEDGAGravUPL_STATUSEnum.EJ_UPPLATEN && !hasFutureDate) {
    return colors.lightGreen;
  }

  //  Upplåten
  if (status === TEDGAGravUPL_STATUSEnum.UPPLATEN) {
    return colors.gray;
  }

  // Default
  return colors.gray;
};

const GravTitelKort: React.FC<{
  nodeData: IGravplatsNode | null | undefined;
}> = ({ nodeData }) => {
  const theme = useTheme();
  const borderColor = getGraveStatusBorderColor(nodeData, theme);

  return (
    <ObjektVyKort
      className="position-relative"
      backgroundColor={borderColor}
      caption="Gravplats"
      border={`3px solid ${borderColor}`}
      /*      button={() => (
        <EDButton
          flat
          label=""
          tooltip="Bevaka"
          size="small"
          icon={
            <EDIcon
              iconType="bookmark_border"
              marginRight={0.5}
              color={'primary'}
              size="small"
            />
          }
        />
      )} */
    >
      <div>
        <EDTypography variant="h5" color="black">
          {nodeData?.GRAVNUMMER_FULLT}
        </EDTypography>
        <div>
          <span>{nodeData?.Kvarter}</span>
        </div>
      </div>
    </ObjektVyKort>
  );
};

export default GravTitelKort;
